import {combineEpics} from 'redux-observable';
import {makeAsyncEpic} from 'common/utils/simplifiedAsync';
import * as api from '../services/api';
import * as actions from './actions';

const sendMail = makeAsyncEpic(actions.sendMail, api.sendMail);
const getChampions = makeAsyncEpic(actions.getChampions, api.getChampions);

export default combineEpics(sendMail, getChampions);
